<template>
  <v-layout row>
    <v-dialog v-model="dialog" max-width="1500px">
      <v-btn small color="primary" slot="activator">View PDF</v-btn>
      <v-card>
        <v-card-title>
          <span class="headline">File Preview</span>
        </v-card-title>
        <v-card-text>
          <iframe width="100%" height="850px" :src="file"></iframe>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
export default {
  props: ["file", "dialog"],
  data() {
    return {
      props: ["file"]
    };
  }
};
</script>
<style>
.v-messages__message {
  color: red;
}
</style>
